var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrLoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53.13 52.9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.6 4.62v6.99h-6.99c1.87-2.74 4.24-5.12 6.99-6.99z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#14439e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.46 6.07h-13.77v5.54h-11.71v-10.18c2.69-.93 5.58-1.43 8.58-1.43 1.06 0 2.1.06 3.13.19 5.2.6 9.94 2.72 13.77 5.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.6 17.78v11.71h-11.43c-.12-.96-.17-1.93-.17-2.92 0-3.08.52-6.04 1.49-8.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.64 17.78h-21.95v-6.17h18.83c1.3 1.9 2.35 3.96 3.12 6.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.13 26.57c0 .99-.05 1.96-.17 2.92h-34.98v-11.71h11.71v5.53h23.23c.14 1.07.21 2.16.21 3.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.75 35.02c-.73 2.2-1.75 4.27-3.01 6.17h-44.35c-1.26-1.9-2.28-3.97-3.01-6.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.85 46.73c-3.83 3.3-8.61 5.51-13.87 6.17h-6.83c-5.26-.66-10.04-2.87-13.87-6.17z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m52.96 29.49c-.2 1.91-.61 3.76-1.21 5.53h-50.37c-.6-1.77-1.01-3.62-1.21-5.53h11.43v-11.71h-10.11c.77-2.21 1.82-4.27 3.12-6.17h6.99v-6.99c1.96-1.34 4.1-2.42 6.38-3.19v10.18h11.71v6.17h-11.71v11.71z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.6 11.61h-6.99c1.87-2.74 4.24-5.12 6.99-6.99z",
    fill: "#14439e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.74 41.19c-1.36 2.07-3.01 3.94-4.89 5.54h-34.57c-1.88-1.6-3.53-3.47-4.89-5.54z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.52 11.61h-18.83v-5.54h13.77c1.94 1.6 3.65 3.47 5.06 5.54z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.92 23.31h-23.23v-5.53h21.95c.62 1.76 1.06 3.62 1.28 5.53z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrLoc);
export default __webpack_public_path__ + "static/media/gr_loc.803bba62081741cc1ff5bacbff6f2c4f.svg";
export { ForwardRef as ReactComponent };